import store from 'store';
import wechatService from '@/services/request/wechatService'

import {
  urlParse,
  getScrollTop
} from '@/utils/utils';

export default {

  data() {
    return {
      
    }
  },

  created() {
  },

  mounted() {
    window._vueInstance = this;
  },

  methods: {

    /**
     * 判断是否在开发环境下
     */
    isDev() {
      const h = window.location.host;
      let res = (h.indexOf('127.0.0.1') !== -1 || h.indexOf('localhost') !== -1 || h.substring(0, 4) === '192.');
      return res;
    },

    /**
     * 判断各种运行环境
     */
    isRunEnv(envName) {
      const u = navigator.userAgent;
      let maps = {
        app: u.indexOf('Finger') !== -1 || u.indexOf('finger') !== -1, // 是否在app中
        wechat: u.indexOf('MicroMessenger') !== -1 && u.indexOf('wxwork') === -1, // 在普通微信中
        wxwork: u.indexOf('MicroMessenger') !== -1 && u.indexOf('wxwork') !== -1, // 在普通微信中
        miniprogram: window.__wxjs_environment === "miniprogram", // 是否在小程序中
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // 是否是安卓
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //是否是ios
      }
      return maps[envName] || false;
    },

    /**
     * 公共客户端初始化方法
     * @param {*} vueInstance 
     * @param {*} isDebug 
     */
    async commonClientInit(vueInstance, isDebug = false) {
      let that = vueInstance;
      return new Promise((resolve, reject) => {
        if (that.page.isInApp) {
          clientService.auth(function (bridge, userInfo) {
            //获取jsbridge
            that.page.clientBridge = bridge;
            if (!!userInfo) {
              that.publicData.iid = userInfo.iid;
              that.publicData.rid = userInfo.rid;
              that.publicData.uid = userInfo.uid;
              that.publicData.headImg = userInfo.headImg; // 用户头像
              that.publicData.signature = userInfo.signature; // 用户签名
              that.publicData.nick_name = userInfo.nick_name; // 用户昵称
              //获取客户端版本号
              if (that.page.clientBridge) {
                that.page.clientBridge.callHandler("getAppInfo", {}, function (
                  data
                ) {
                  if (typeof data === "string") {
                    data = JSON.parse(data);
                    that.page.versionCode = data.appInfo.versionCode;
                    if (isDebug === true) {
                      that.debug.logs.push({
                        time: new Date().getTime(),
                        text: `AppVersionCode: ${that.page.versionCode}`
                      });
                    }
                    resolve(true);
                  } else {
                    reject(false);
                  }
                });
              } else {
                reject(false);
              }
            }
            if (isDebug === true) {
              that.debug.logs.push({
                time: new Date().getTime(),
                text: `bridge.userInfo: ${JSON.stringify(userInfo)}`
              });
            }
          });
        } else {
          resolve(false);
        }
      });
    },

    /**
     * 微信端初始化方法
     * @param {*} vueInstance 
     * @param {*} isDebug 
     */
    async commonWechatInit(vueInstance,callback, isDebug = false) {
      if(this.isDev()) return
      let that = vueInstance;
      return new Promise((resolve, reject) => {
        if (this.isRunEnv('wechat')) {
          //微信授权
          let iid = that.$route.query.iid || '';
          wechatService.auth(
            iid,
            ({
              openid,
              unionid, 
              nickname, 
              headimgurl
            }) => {
              if (!!openid) {
                //初始化jsapi接口
                if(typeof callback === "function"){
                  callback({
                    openid: openid,
                    unionid:unionid,
                    nickname:nickname,
                    headimgurl:headimgurl
                  });
                }
                resolve(true);
              }
            },
            true
          );
        } else {
          resolve(false);
        }
      });
    },

    /**
     * 微信端分享初始化方法
     * @param {*} vueInstance 
     * @param {*} isDebug 
     */
    async commonWechatShareInit(vueInstance, shareConfig, isDebug = false) {
      if(this.isDev()) return
      let fullPath = window.location.origin + this.$route.fullPath;
      console.log('fullPath', fullPath);
      let newUrl = '';
      if (typeof shareConfig.link === 'string') {
        newUrl = shareConfig.link;
      } else {
        newUrl = urlParse(fullPath, shareConfig.link || {});
      }
      let _shareConfig = {
        title: shareConfig.title,
        desc: shareConfig.desc,
        imgUrl: shareConfig.imgUrl,
        link: newUrl
      }
      console.log(_shareConfig);
      let that = vueInstance;
      return new Promise((resolve, reject) => {
        if (that.isRunEnv("wechat")) {
          let  iid = that.$route.query.iid || '';
          if (iid) {
            wechatService.auth(
              iid,
              ({
                openid,
                unionid
              }) => {
                //微信分享初始化
                wechatService.jsapi(iid, _shareConfig, [
                  "onMenuShareTimeline",
                  "onMenuShareAppMessage",
                  "chooseWXPay",
                  "chooseImage",
                ]);
                resolve(true);
              }, true);
          } else {
            //微信分享初始化
            wechatService.jsapi(iid, _shareConfig, [
              "onMenuShareTimeline",
              "onMenuShareAppMessage",
              "chooseWXPay",
            ]);
          }
        } else {
          resolve(false);
        }
      });
    },

    /**
     * 判断网页是否滚动到底部
     * @param {} callback 
     */
     onScrollBottom(callback) {
      let that = this;
      var scrollToBottom = {
        getScrollTop: getScrollTop,
        getScrollHeight: function () {
          var scrollHeight = 0,
            bodyScrollHeight = 0,
            documentScrollHeight = 0;
          if (document.body) {
            bodyScrollHeight = document.body.scrollHeight;
          }
          if (document.documentElement) {
            documentScrollHeight = document.documentElement.scrollHeight;
          }
          scrollHeight =
            bodyScrollHeight - documentScrollHeight > 0 ?
            bodyScrollHeight :
            documentScrollHeight;
          return scrollHeight;
        },
        getClientHeight: function () {
          var windowHeight = 0;
          if (document.compatMode == "CSS1Compat") {
            windowHeight = document.documentElement.clientHeight;
          } else {
            windowHeight = document.body.clientHeight;
          }
          return windowHeight;
        },
        onScrollEvent: function (callback) {
          var This = this;
          //window.scrollTo(0,document.body.scrollHeight)
          window.onscroll = function () {
            console.log(999)
            if (
              This.getScrollTop() + This.getClientHeight() >=
              This.getScrollHeight()
            ) {
              typeof callback == "function" && callback.call(this);
            }
          };
        }
      };
      scrollToBottom.onScrollEvent(function () {
        console.log(999)
        if (typeof callback === "function") {
          callback();
        }
      });
    },

    /**
     * 跳转链接
     */
    goLink(url, $router) {
      console.log('url',url)
      if(!url){
        return
      }
      if (this.isRunEnv('ios') || this.isRunEnv('miniprogram') || url[0] === '/' || url[0] === '\\' || url.indexOf('http://') != -1|| url.indexOf('https://') != -1) {
        window.location.href = url;
      } else {
        if ($router) {
          $router.push({
            path: url
          });
        }
      }
    }

  }
}
